import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from "@mui/material";

export const SaveDialog = ({ open, onConfirm, onCancel, t }) => (
  <Dialog open={open} onClose={onCancel} PaperProps={{ sx: { borderRadius: 2, p: 1 } }}>
    <DialogTitle sx={{ fontWeight: 700 }}>{t.saveDialogTitle}</DialogTitle>
    <DialogContent>
      <DialogContentText>{t.saveDialogMessage}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{ borderRadius: 1.5, borderColor: "#163666", color: "#163666" }}
      >
        {t.cancel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        autoFocus
        sx={{ borderRadius: 1.5, backgroundColor: "#163666" }}
      >
        {t.confirm}
      </Button>
    </DialogActions>
  </Dialog>
);
